import { Component, Input, ViewChild } from '@angular/core'
import { Application } from 'src/app/account/services/application.service'
import { SyncPairPermissionIssue } from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { environment } from 'src/environments/environment'
import { ModalDialogComponent } from '../../../../shared/modal-dialog/modal-dialog.component'
import { ApplicationType } from '../../../../services/dtos'

@Component({
  selector: 'sync-pair-permission-issue',
  templateUrl: './sync-pair-permission-issue.component.html',
  styleUrls: ['./sync-pair-permission-issue.component.scss'],
  standalone: false,
})
export class SyncPairPermissionIssueComponent {
  @Input() issue: SyncPairPermissionIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null
  @ViewChild('updateAccessDialog', { static: true }) updateAccessDialog: ModalDialogComponent

  constructor() {}

  get productName() {
    return environment.productName
  }

  get applicationType() {
    return this.application?.type || ApplicationType.AWS
  }

  get sourceEndpointUri() {
    return !!this.syncPair ? this.syncPair.sourceEndpointUri : this.application.sourceEndpointUri
  }

  get targetEndpointUri() {
    return !!this.syncPair ? this.syncPair.targetEndpointUri : this.application.targetEndpointUri
  }

  public showAccessDialog(event) {
    event.preventDefault()
    this.updateAccessDialog.open()
  }

  public dismissAccessDialog() {
    this.updateAccessDialog.close()
  }
}
